import React from 'react';
import { Col, ListGroup, Button } from 'react-bootstrap';
import { format } from 'date-fns'; // Make sure you have date-fns installed

const EventList = ({ events, handleDelete, viewOption }) => {
    // Helper function to format the event date and time
    const formatDateTime = (date) => format(new Date(date), 'MMM dd, yyyy - HH:mm');

    // Get today's date in YYYY-MM-DD format
    const today = new Date().toISOString().split('T')[0];

    // Filter events based on the view option
    const filteredEvents = viewOption === 'today'
        ? events.filter(event => new Date(event.date).toISOString().split('T')[0] === today)
        : events;

    return (
        <Col xs={12} md={8} lg={6}>
            <ListGroup className="">
                {filteredEvents.length === 0 && (
                    <ListGroup.Item className="text-center">
                        {viewOption === 'today' ? 'No events scheduled for today' : 'No events available'}
                    </ListGroup.Item>
                )}
                {filteredEvents.map((event) => (
                    <ListGroup.Item key={event._id} className="event-item">
                        <div className="event-details">
                            <strong>{event.name}</strong> - {formatDateTime(event.date)}
                        </div>
                        <Button variant="outline-danger" size="sm" onClick={() => handleDelete(event._id)}>
                            Delete
                        </Button>
                    </ListGroup.Item>
                ))}
            </ListGroup>
        </Col>
    );
};

export default EventList;
